import { Delete } from '@mui/icons-material'

export enum GridFileTypeOption {
    solidGeochemicalData,
    trash,
}

export type FileTypeNavItemData = {
    gridOption: GridFileTypeOption
    label: string
    icon: React.ReactElement
    enabled: boolean
}

export const fileTypeNavItems = [
    {
        gridOption: GridFileTypeOption.solidGeochemicalData,
        label: 'Solid Geochemical Data',
        icon: <img alt="Element Icon" className="icon" src="/images/element.svg" />,
        enabled: true,
    },
    {
        gridOption: GridFileTypeOption.trash,
        label: 'Trash',
        icon: <Delete />,
        enabled: true,
    },
]

export type SolidGeochemicalFile = {
    fileName: string
    associatedSampleIDs: string[]
    vendor: string
    uploadDate: string
}
